'use strict'
import { request } from '../../plugins/http'

export default async (callId, callType) => {
    return await request.get('/atendimento',{params:{callId:callId, callType: callType}})
}